<template>
  <div class="transit-container">
    <div class="camera-box">
      <video ref="video" autoplay></video>
      <canvas ref="canvas" style="display: none"></canvas>
      <el-input
        v-model="phone"
        placeholder="手机号"
        style="margin-bottom: 15px"
      ></el-input>
      <el-button-group>
        <el-button type="primary" @click="startCamera" :disabled="isCameraOn">
          开启摄像头
        </el-button>
        <el-button
          type="success"
          :disabled="!isCameraOn"
          @click="handleSign('signin')"
        >
          签到
        </el-button>
        <el-button
          type="warning"
          :disabled="!isCameraOn"
          @click="handleSign('signout')"
        >
          签离
        </el-button>
      </el-button-group>
    </div>

    <!-- 通行记录展示 -->
    <div class="records">
      <h3>最近记录：</h3>
      <el-timeline>
        <el-timeline-item
          v-for="(record, index) in records"
          :key="index"
          :timestamp="formatTime(record.timestamp)"
          placement="top"
        >
          <el-tag :type="record.action === 'signout' ? 'success' : 'warning'">
            {{ record.action === "signout" ? "离开" : "进入" }}
          </el-tag>
          {{ record.phone }} - {{ record.visitorName }}
          <br />
          
        </el-timeline-item>
      </el-timeline>
    </div>
    <div >
      <footers/>
    </div>
  </div>
</template>

<script>
import * as faceapi from "face-api.js";
import footers from '../components/footer.vue'

export default {
  components: {
    footers
  },
  data() {
    return {
      isCameraOn: false,
      phone: "",
      video: null,
      canvas: null,
      modelsLoaded: false,
      detectionsInterval: null,
      records: [],
    };
  },
  async mounted() {
    this.video = this.$refs.video;
    this.canvas = this.$refs.canvas;

    // 加载 face-api.js 模型
    await this.loadModels();

    // 确保模型加载完成后再继续
    if (this.modelsLoaded) {
      console.log("Models loaded successfully");
    } else {
      console.error("Models failed to load");
    }

    // 加载通行记录
    this.loadRecords();
  },
  methods: {
    async loadModels() {
      const MODEL_URL = "/models";

      try {
        await Promise.all([
          faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL),
          faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL),
          faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL),
          faceapi.nets.faceExpressionNet.loadFromUri(MODEL_URL),
        ]);
        this.modelsLoaded = true;
        this.$message.success("模型加载完成");
      } catch (error) {
        this.$message.error("模型加载失败：" + error.message);
      }
    },

    async startCamera() {
      if (!this.modelsLoaded) {
        this.$message.error("模型尚未加载完成");
        return;
      }

      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        this.video.srcObject = stream;
        this.isCameraOn = true;

        this.video.addEventListener("play", () => {
          this.detectionsInterval = setInterval(async () => {
            await this.detectFaces();
          }, 1000);
        });
      } catch (error) {
        this.$message.error("摄像头启动失败：" + error.message);
      }
    },

    async detectFaces() {
      if (!this.video || !this.canvas) return;

      const detections = await faceapi
        .detectAllFaces(this.video, new faceapi.TinyFaceDetectorOptions())
        .withFaceLandmarks()
        .withFaceExpressions();

      if (detections.length > 0) {
        const ctx = this.canvas.getContext("2d");
        ctx.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);
        faceapi.draw.drawDetections(this.canvas, detections);
        faceapi.draw.drawFaceLandmarks(this.canvas, detections);
      }
    },

    async handleSign(type) {
      if (!this.modelsLoaded || !this.isCameraOn) {
        this.$message.error("摄像头或模型未准备好");
        return;
      }

      const video = this.$refs.video; // 确保视频元素引用正确
      const detections = await faceapi
        .detectAllFaces(video, new faceapi.TinyFaceDetectorOptions())
        .withFaceLandmarks()
        .withFaceDescriptors();

      if (detections.length === 0) {
        this.$message.error("未检测到人脸");
        return;
      }

      console.log("Detected faces:", detections); // 添加日志

      try {
        let photoBase64 = this.canvas.toDataURL("image/png");
        const userResponse = await this.$http.post("/order-transit", {
          userId: this.phone, // 修改为 userId
          action: type,
          photo: photoBase64.split(",")[1],
        });

        if (!userResponse.success) {
          throw new Error(
            userResponse.message || `${type === "signin" ? "签到" : "签离"}失败`
          );
        }

        this.$message.success(`${type === "signin" ? "签到" : "签离"}成功`);
        if (type === "signin" || type === "signout") {
          this.stopCamera();
          this.phone = "";
          this.loadRecords(); // 刷新记录
        }
      } catch (error) {
        console.error("操作失败:", error);
        this.$message.error(error.response?.message || error.message);
      }
    },

    stopCamera() {
      if (this.video.srcObject) {
        this.video.srcObject.getTracks().forEach((track) => track.stop());
      }

      clearInterval(this.detectionsInterval);
      this.isCameraOn = false;
    },

    async loadRecords() {
      try {
        const res = await this.$http.get("/order-transits");
        this.records = res.slice(0, 5); // 只保留最新的五条记录
      } catch (error) {
        console.error("加载记录失败:", error);
        this.$message.error("加载记录失败，请稍后再试");
      }
    },

    formatTime(timestamp) {
      if (!timestamp) return "未知";
      return new Date(timestamp).toLocaleString("zh-CN", {
        year: "numeric", // 年
        month: "2-digit", // 月
        day: "2-digit", // 日
        hour12: false, // 使用24小时制
        hour: "2-digit", // 小时
        minute: "2-digit", // 分钟
        second: "2-digit", // 秒
      });
    },

    beforeDestroy() {
      this.stopCamera();
    },
  },
};
</script>

<style scoped>
.transit-container {
  display: flex;
  width: 100%;
  height: 90%; /* 使用视口高度单位 */
}

.camera-box, .records {
  flex: 1; /* 平分可用空间 */
  padding: 1rem;
}

.camera-box {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

video {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  transform: scaleX(-1); /* 镜像显示 */
}

canvas {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}

.records {
  font-size: 0.9rem;
  border-left: 1px solid #ddd;
}

@media (max-width: 768px) {
  .transit-container {
    flex-direction: column;
    height: auto;
  }

  .camera-box, .records {
    height: auto;
    max-height: none;
  }
}
</style>